import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { Card, Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { es } from 'date-fns/locale';
import { useQuery } from '../../../utils/useQuery';
import { useHistory } from 'react-router-dom';
import { registerLocale } from 'react-datepicker';
import apiAxios from '../../../config/ApiAxios';
import 'react-datepicker/dist/react-datepicker.css';
import { FormatterNumber } from '../../../utils/formatter';

registerLocale('es', es);

const LimitePersonasApilado = () => {
	// DATOS DE AGRUPAMIENTO
	const asignadoGrupoDefault = 75000;
	const porcentajeGrupoDefault = 91;

	const [asignadoGrupo, setAsignadoGrupo] = useState(asignadoGrupoDefault);
	const [porcentajeGrupo, setPorcentajeGrupo] = useState(
		porcentajeGrupoDefault
	);

	//MODAL
	const [show, setShow] = useState(false);
	const [modalSaved, setModalSaved] = useState(false);
	const handleClose = () => {
		setShow(false);
		setAsignadoGrupo(asignadoGrupoDefault);
		setPorcentajeGrupo(porcentajeGrupoDefault);
	};
	const handleShow = () => setShow(true);
	const handleSave = () => {
		setModalSaved(!modalSaved);
		setShow(false);
	};

	const [series, setSeries] = useState([]);
	const [categories, setCategories] = useState([]);

	useEffect(() => {
		const obtenerCreditos = async () => {
			try {
				const url = `/reportes/global/personas/limite?agrupar_por[]=limite_asignado
				&agrupar_por[]=porcentaje_utilizado
				&asignado_grupo=${asignadoGrupo}
				&porcentaje_grupo=${porcentajeGrupo}
				`;

				const apiResponse = await apiAxios.get(url);

				if (apiResponse?.status === 200) {
					const data = apiResponse.data;

					// Agrupamos por grupo_limite_asignado
					const groupedByLimite = {};

					data.forEach((item) => {
						const grupoLimite = `${item.grupo_limite_asignado}`;
						const grupoUso = `${item.grupo_porcentaje_utilizado}`;

						if (!groupedByLimite[grupoUso]) {
							groupedByLimite[grupoUso] = {};
						}
						groupedByLimite[grupoUso][grupoLimite] =
							item.total_clientes;
					});

					// Obtener categorías únicas
					const allCategories = [
						...new Set(
							data.map(
								(item) =>
									`${item.grupo_limite_asignado}`
							)
						),
					];
					setCategories(allCategories);

					// Armar series para cada grupo de uso
					const chartSeries = Object.entries(
						groupedByLimite
					).map(([grupoUso, limiteData]) => ({
						name: grupoUso,
						data: allCategories.map(
							(cat) => limiteData[cat] || 0
						),
					}));
					setSeries(chartSeries);
				}
			} catch (e) {
				console.log(e);
			}
		};

		obtenerCreditos();
	}, [modalSaved]);

	const options = {
		chart: {
			type: 'bar',
			stacked: true,
		},
		plotOptions: {
			bar: {
				horizontal: true,
				borderRadius: 4,
				borderRadiusApplication: 'end',
			},
		},
		tooltip: {
			x: {
				//MONTO ASIGNADO
				formatter: function (val) {
					return (
						FormatterNumber(val) +
						' o más (de limite asignado)'
					);
				},
			},
			y: {
				//Cantidad de Clientes
				formatter: function (val, { seriesIndex }) {
					return val + ' cliente/s';
				},
				// Porcentaje de uso
				title: {
					formatter: (seriesName) =>
						seriesName + '% de límite utilizado (o más):',
				},
			},
		},
		xaxis: {
			categories: categories,
			title: {
				text: 'Cantidad de clientes',
			},
			labels: {
				formatter: (label) => label + ' cliente/s',
			},
		},
		yaxis: {
			title: {
				text: 'Rango de límite asignado al cliente',
				style: {
					fontSize: '15px',
				},
			},
			labels: {
				formatter: (limiteAsignado) =>
					'+' + FormatterNumber(limiteAsignado),
			},
		},
		legend: {
			position: 'bottom',
			formatter: (legendName) => '+' + legendName + '%',
		},
	};

	const query = useQuery();
	const history = useHistory();

	const ocultarGrafico = query.get('ocultarGrafico');

	const ocultarGraficoArray = ocultarGrafico
		? ocultarGrafico.replace(/[[\]]/g, '').split(',').map(Number)
		: [];
	return (
		<div
			className="column-card"
			style={{
				display: ocultarGraficoArray.includes(4) ? 'none' : 'block',
			}}>
			<div className="px-2 py-2 border border-bottom-0 d-flex align-items-center gap-1">
				<Button
					className="ms-auto"
					variant="primary"
					onClick={handleShow}>
					Asignar Grupos
				</Button>
			</div>
			<Card>
				<Card.Body>
					<Card.Title>
						Distribución de uso por límite asignado
					</Card.Title>
					<Chart type="bar" options={options} series={series} />
				</Card.Body>
			</Card>
			<Modal centered show={show} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>Agrupaciones dinámicas</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<InputGroup className="mb-3">
						<InputGroup.Text>Cada $</InputGroup.Text>
						<Form.Control
							type="number"
							min={25000}
							defaultValue={asignadoGrupo}
							onChange={(e) =>
								setAsignadoGrupo(Number(e.target.value))
							}
						/>
						<InputGroup.Text>
							de límite asignado
						</InputGroup.Text>
					</InputGroup>
					<InputGroup className="mb-3">
						<InputGroup.Text>Cada</InputGroup.Text>
						<Form.Control
							type="number"
							min={5}
							defaultValue={porcentajeGrupo}
							onChange={(e) =>
								setPorcentajeGrupo(
									Number(e.target.value)
								)
							}
						/>
						<InputGroup.Text>
							% de uso del límite
						</InputGroup.Text>
					</InputGroup>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="primary" onClick={handleSave}>
						Guardar
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
};

export default LimitePersonasApilado;
